import { createSlice } from '@reduxjs/toolkit';

const initialHewanKurbanState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    hewanKurbanForEdit: undefined,
    roleMaster: [],
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const hewanKurbanSlice = createSlice({
    name: 'hewanKurban',
    initialState: initialHewanKurbanState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // getHewanKurbanById
        hewanKurbanFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.hewanKurbanForEdit = action.payload.hewanKurbanForEdit;
        },
        // findHewanKurban
        hewanKurbansFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        roleMasterFetched: (state, action) => {
            state.actionsLoading = false;
            state.roleMaster = action.payload.roleMaster;
            state.error = null;
        },

        // Set to default state actionLoading & error
        hewanKurbanReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

